module.exports = __webpack_public_path__ + "img/logo4.2f53c771.png";